"use client";

import type { FC, Ref } from "react";
import { Image } from "@huub-web/ui/components/Image";

export interface ImageTemplateProps {
  src: string;
  alt: string;
}

export const ImageTemplate: FC<
  ImageTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ src, alt, ref }) => <Image ref={ref} src={src} alt={alt} borderRadius />;
